import { type WrappedInsightMorningMvpAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Span, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import chickenIcon from "../../assets/chicken-wrapped.png";

interface MorningMvpContentProps {
  attributes: WrappedInsightMorningMvpAttributes;
}

export function MorningMvpContent(props: MorningMvpContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative">
      {/* Chicken image - positioned center-right */}
      <Box
        position="absolute"
        sx={{
          top: "25%",
          right: "-15%",
        }}
      >
        <Image src={chickenIcon} alt="Chicken" width={320} height={320} />
      </Box>

      {/* Text section - bottom left */}
      <Stack
        position="absolute"
        sx={{
          bottom: "12%",
          left: "7.7%",
        }}
        gap={1}
      >
        <Text variant="body1" color="white">
          You are a
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          Morning
        </Text>
        <Text variant="h1" color="white" sx={{ fontSize: "3.5rem", lineHeight: 1 }}>
          MVP
        </Text>
        <Text variant="body2" sx={{ marginTop: 2 }}>
          <Span sx={{ fontWeight: 500, color: "white" }}>{attributes.amShifts} AM Shifts</Span>
          <Span sx={{ color: "rgba(255, 255, 255, 0.6)" }}>
            {" "}
            · {attributes.pmShifts} PM Shifts · {attributes.nocShifts} NOC Shifts
          </Span>
        </Text>
      </Stack>
    </Stack>
  );
}
